import { useState, useEffect } from "react";
import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Input, message, type GetProps } from "antd";
import icon from "../../assets/images/Ellipse 286.svg";
import {
  codeResend,
  loginWithPhone,
  verifyCode,
} from "../../services/auth/login";
import { useCart } from "../../services/menu/useCart";

interface LoginModalProps {
  isOpen: boolean;
  onClose: (reason?: string) => void;
}
type OTPProps = GetProps<typeof Input.OTP>;

const Login: React.FC<LoginModalProps> = ({ isOpen, onClose }) => {
  const [phone, setPhone] = useState("");
  const [touched, setTouched] = useState(false);
  const [code, setCode] = useState("");
  const [codeModalOpen, setCodeModalOpen] = useState(false);
  const [userId, setUserId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [timer, setTimer] = useState(0);
  const [messageApi, contextHolder] = message.useMessage();
  const { syncLocalCartToBackend } = useCart();

  // O'zbekiston raqami +998 bilan 12 ta raqam bo'ladi
  const isValid = phone.length === 12;

  const onChange: OTPProps["onChange"] = (text) => {
    setCode(text);
    if (text.length === 4) {
      handleVerifyCode(text);
    }
  };

  const sharedProps: OTPProps = {
    onChange,
  };

  // Telefon raqam yuborish
  const handleSendPhone = async () => {
    if (!isValid) {
    setTouched(true); 
    messageApi.error("Iltimos, to‘liq telefon raqamingizni kiriting");
    return;
  }
    setLoading(true);
    try {
      const res = await loginWithPhone(`+${phone}`);
      setUserId(res.user);
      setCodeModalOpen(true);
      setTimer(res.time * 60); 
      messageApi.success("Telefon raqamingizga kod yuborildi");
      onClose();
    } catch (err) {
      console.error("Xatolik:", err);
      messageApi.error("Telefon raqamingizga kod yuborishda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };

  // Kod yuborish
  const handleVerifyCode = async (currentCode?: string) => {
    try {
      const finalCode = currentCode ?? code;
      if (userId && finalCode.length === 4) {
        const res = await verifyCode(finalCode, userId);
        // console.error(res.data.access);
        
        messageApi.success("Tasdiqlandi");
        localStorage.setItem("access", res.data.access);
        localStorage.setItem("refresh", res.data.refresh);
        await syncLocalCartToBackend();
        setOtpError(false);
        setCodeModalOpen(false);
        window.location.reload();
      }
    } catch (err) {
      console.error("Xatolik:", err);
      setOtpError(true); // katakchalarni qizil qilish
      messageApi.error("Kodni tasdiqlashda xatolik yuz berdi");
    }
  };

  // Kod qayta yuborish
  const handleResendCode = async () => {
    try {
      const res = await codeResend(`+${phone}`);
      setUserId(res.user);
      setTimer(res.time * 60 || 60);
      setOtpError(false);
      messageApi.success("Telefon raqamingizga kod qayta yuborildi");
    } catch (err) {
      console.error("Xatolik:", err);
      messageApi.error("Telefon raqamini yuborishda xatolik yuz berdi");
    }
  };

  // Timerni kamaytirish
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  return (
    <div>
      {contextHolder}
      {/* LOGIN MODAL */}
      <Modal isOpen={isOpen} onClose={() => onClose("manual")} className="max-w-[380px] ">
        <div className="md:px-6 md:py-6">
          <h2 className="text-2xl font-bold text-center mb-6 text-gray-900">
            Amaar Marketga kirish
          </h2>
          <div className="w-full">
            <PhoneInput
              country={"uz"}
              onlyCountries={["uz"]}
              masks={{ uz: "(..) ...-..-.." }}
              value={phone}
              inputStyle={{
                width: "100%",
                height: "50px",
                color: "#111827",
                fontSize: "18px",
                borderRadius: "12px",
                border:
                  touched && !isValid ? "1px solid #ef4444" : "1px solid #e5e7eb",
                backgroundColor: "#f9fafb",
                padding: "0 15px",
                boxSizing: "border-box",
              }}
              containerClass="w-full"
              placeholder="+998 00 000-00-00"
              onBlur={() => setTouched(true)}
              onChange={(value) => setPhone(value)}
              onKeyDown={(e => {
                if (e.key === "Enter") {
                  handleSendPhone();
                }
              })}
            />
            {touched && !isValid && (
              <p className="text-red-500 text-sm mt-1">
                Iltimos, telefon raqamingizni to‘liq kiriting
              </p>
            )}
          </div>

          <Button
            text={loading ? "loading..." : "Kodni olish"}
            backgroundColor="#000"
            textColor="#fff"
            padding="12px"
            width="100%"
            style={{ marginTop: "25px" }}
            onClick={handleSendPhone}
          />

          <p className="text-sm text-gray-500 mt-20 text-center leading-5 max-w-max">
            Davom etgan holda men{" "}
            <a href="#" className="text-[#000]">
              shaxsiy ma'lumotlarni qayta ishlash siyosatiga rozilik bildiraman
            </a>{" "}
            va{" "}
            <a href="#" className="text-[#000]">
              ommaviy oferta bilan roziman
            </a>
            .
          </p>
        </div>
      </Modal>

      {/* CODE MODAL */}
      <Modal
        isOpen={codeModalOpen}
        onClose={() => {
          setCodeModalOpen(false);
          onClose("manual");
        }}
        className="max-w-[380px]"
      >
        <div className="flex flex-col items-center px-6 py-6">
          <h2 className="text-2xl font-bold text-center mb-6 text-gray-900">
            Kodni kiriting
          </h2>
          <p className="text-md mb-4 text-center">
            Telefonni tasdiqlash uchun{" "}
            <span className="font-bold text-[17px]">+{phone}</span> raqamiga 4
            xonali kod yuborildi.
          </p>
          <div className="my-5">
            <Input.OTP
              length={4}
              formatter={(str) => str.replace(/[^0-9]/g, "")}
              autoComplete="one-time-code"
              inputMode="numeric"
              pattern="[0-9]*"
              {...sharedProps}
              status={otpError ? "error" : ""}
            />
          </div>

          {/* <Button
            text="Tasdiqlash"
            backgroundColor="#000"
            textColor="#fff"
            padding="12px"
            width="100%"
            style={{ marginTop: "25px" }}
            onClick={handleVerifyCode}
          /> */}

          {timer > 0 ? (
            <p className="text-md text-center flex gap-2 mt-10 items-center text-black">
              Agar sizga kod kelmagan bo'lsa, {timer} soniyadan so'ng qayta yuborish mumkin.
            </p>
          ) : (
            <p
              className="text-md flex gap-2 mt-10 items-center cursor-pointer text-blue-700 hover:underline"
              onClick={handleResendCode}
            >
              <img className="w-[20px]" src={icon} alt="Resend code" />
              Kodni qayta yuborish
            </p>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default Login;
